import $ from 'jquery';
import { t } from 'global/translations';


$(function () {

});

$(function () {
    $(".show-advanced-search").on('click', function () {
        const $this = $(this);
        if ($this.hasClass('filter')) {
            $this.toggleClass('filter');
            $(".advanced-search").fadeToggle();
            $this.text(t(I18n.locale, 'less-filters'));

        } else {
            $this.toggleClass('filter');
            $(".advanced-search").fadeToggle(400, function () {
                $this.text(t(I18n.locale, 'more-filters'));
            });
        }
    });

    let isUpdating = false;
    $("input[name='map_search_selector']").on("change", function (element) {
        if (isUpdating) return;

        isUpdating = true;
        if (element.target.checked) {
            $("input[name='map_search_selector']").prop("checked", true);
            sessionStorage.setItem("search_view", "map");
        } else {
            $("input[name='map_search_selector']").prop("checked", false);
            sessionStorage.setItem("search_view", "list");
        }
        isUpdating = false;
    });
});
